document.addEventListener("DOMContentLoaded", function () {
  const stickyElement = document.querySelector(".product__column-sticky");
  const headerElement = document.querySelector(".section-header");

  function updateStickyTop() {
    if (!stickyElement || !headerElement) return; // Ensure elements are present

    const headerHeight = headerElement.offsetHeight; // Get the height of .section-header
    const scrolledPastHeader = document.body.classList.contains("scrolled-past-header");

    if (scrolledPastHeader) {
      stickyElement.style.top = `calc(3rem + ${headerHeight}px)`; // Add extra height
    } else {
      stickyElement.style.top = "3rem"; // Default top value
    }
  }

  // Debounce function to limit how often updateStickyTop is called
  function debounce(func, delay) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  }

  // Initial update
  updateStickyTop();

  // Debounced event listener for scroll
  window.addEventListener("scroll", debounce(updateStickyTop, 50));

  // Event listener for window resize
  window.addEventListener("resize", updateStickyTop);
});


class VariantAccordion extends HTMLElement {
  constructor() {
    super();
  }
  
  connectedCallback() {
    this.initFunction();
  }
  
  initFunction() {
    // Select all accordions within the custom element
    let accordions = this.querySelectorAll('.accordian');

    // Check if there are any accordions and iterate over them
    if (accordions.length) {
      accordions.forEach((element) => {
        let icon = element.querySelector('.custom-icon-arrow');
        let answer = element.querySelector('.answer');
        let question = element.querySelector('.question');

        // Add click event listener to each accordion
        element.addEventListener('click', () => {
          if (question.classList.contains('open')) {
            question.classList.remove('open');
            answer.style.maxHeight = null; // Collapse the answer
          } else {
            question.classList.add('open');
            answer.style.maxHeight = answer.scrollHeight + 'px'; // Expand the answer
          }
        });
      });
    }
  }
}
// // Define the custom element
customElements.define('variant-accordion', VariantAccordion);

let accordian = document.querySelectorAll('.myaccordian');
if (accordian && accordian.length > 0) {
  Array.from(accordian).forEach(function(element) {
    let icon = element.querySelector('.custom-icon-arrow');
    let answer = element.querySelector('.answer');
    let question = element.querySelector('.question');
    if (question && answer) {
      element.addEventListener('click', function() {
        if (question.classList.contains('open')) {
          question.classList.remove('open');
          answer.style.maxHeight = null;
        } else {
          question.classList.add('open');
          answer.style.maxHeight = answer.scrollHeight + 'px';
        }
      });
    }
  });
}

// Social Proof Popup
(function() {
  'use strict';

  // Message templates
  const messages = [
    function() {
      const count = Math.floor(Math.random() * 6) + 2; // 2-7
      return count + ' people just purchased';
    },
    function() {
      const count = Math.floor(Math.random() * 6) + 2; // 2-7
      return count + ' people just purchased';
    },
    function() {
      const count = Math.floor(Math.random() * 15) + 5; // 5-19
      return count + ' people viewed this in the last hour';
    },
    function() {
      const count = Math.floor(Math.random() * 12) + 3; // 3-14
      return count + ' people bought this today';
    },
    function() {
      return 'Popular item today';
    },
    function() {
      const count = Math.floor(Math.random() * 8) + 2; // 2-9
      return count + ' people added this to cart';
    },
    function() {
      const count = Math.floor(Math.random() * 10) + 4; // 4-13
      return count + ' people are viewing this now';
    }
  ];

  function initSocialProofPopup() {
    const popups = document.querySelectorAll('.social-proof-popup');
    
    if (popups.length === 0) {
      return; // No popups found
    }
    
    popups.forEach(function(popup) {
      // Skip if already initialized to prevent multiple initializations
      if (popup.dataset.initialized === 'true') {
        return;
      }
      
      // Mark as initialized
      popup.dataset.initialized = 'true';
      
      // Get section ID from popup id attribute or parent
      let sectionId = '';
      if (popup.id) {
        sectionId = popup.id.replace('social-proof-popup-', '');
      } else {
        // Try to find section ID from parent
        const productInfo = popup.closest('[data-section]');
        if (productInfo) {
          sectionId = productInfo.getAttribute('data-section') || '';
        }
      }
      
      const storageKey = 'social_proof_dismissed_' + sectionId;
      
      // Check if popup was dismissed
      if (localStorage.getItem(storageKey) === 'true') {
        return; // Don't show if dismissed
      }

      const closeBtn = popup.querySelector('.social-proof-popup__close');
      const messageEl = popup.querySelector('.social-proof-popup__message');
      
      if (!messageEl) {
        console.warn('Social proof popup message element not found');
        return;
      }

      // Add transition for smooth fade-in/out
      popup.style.transition = 'opacity 0.3s ease';

      // Show popup - use !important via style to override inline styles
      popup.style.setProperty('display', 'block', 'important');
      popup.style.setProperty('visibility', 'visible', 'important');
      popup.style.setProperty('opacity', '1', 'important');

      // Set initial message
      let currentIndex = Math.floor(Math.random() * messages.length);
      messageEl.textContent = messages[currentIndex]();

      // Rotate messages every 2 minutes - hide popup completely, then show new message
      const rotateInterval = setInterval(function() {
        // Hide the entire popup
        popup.style.setProperty('display', 'none', 'important');
        popup.style.setProperty('opacity', '0', 'important');
        
        // After a brief pause, show it again with new message
        setTimeout(function() {
          currentIndex = (currentIndex + 1) % messages.length;
          messageEl.textContent = messages[currentIndex]();
          // Show popup again with fade-in
          popup.style.setProperty('display', 'block', 'important');
          popup.style.setProperty('opacity', '0', 'important');
          setTimeout(function() {
            popup.style.setProperty('opacity', '1', 'important');
          }, 50);
        }, 1000); // Wait 1 second before showing new message
      }, 120000); // 2 minutes = 120000ms

      // Handle close button
      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          popup.style.display = 'none';
          localStorage.setItem(storageKey, 'true');
          clearInterval(rotateInterval);
        });
      }

      // Add fade transition for message changes
      messageEl.style.transition = 'opacity 0.15s ease';
    });
  }

  // Initialize multiple times to catch different load scenarios
  function tryInit() {
    initSocialProofPopup();
  }

  // Try on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tryInit);
  } else {
    tryInit();
  }

  // Also try after various delays to catch late-loading content
  setTimeout(tryInit, 500);
  setTimeout(tryInit, 1000);
  setTimeout(tryInit, 2000);
  
  // Try on window load as well
  window.addEventListener('load', tryInit);

  // Hide popups when hamburger menu is opened (mobile)
  function hidePopupsOnMenuOpen() {
    const menuDrawerContainer = document.getElementById('Details-menu-drawer-container');
    if (menuDrawerContainer) {
      menuDrawerContainer.addEventListener('toggle', function() {
        const popups = document.querySelectorAll('.social-proof-popup');
        if (menuDrawerContainer.hasAttribute('open')) {
          // Menu opened - hide all popups
          popups.forEach(function(popup) {
            popup.style.setProperty('display', 'none', 'important');
            popup.style.setProperty('visibility', 'hidden', 'important');
            popup.style.setProperty('opacity', '0', 'important');
          });
        } else {
          // Menu closed - show popups again (if they weren't dismissed)
          popups.forEach(function(popup) {
            if (popup.dataset.initialized === 'true') {
              const sectionId = popup.id ? popup.id.replace('social-proof-popup-', '') : '';
              const storageKey = 'social_proof_dismissed_' + sectionId;
              if (localStorage.getItem(storageKey) !== 'true') {
                popup.style.setProperty('display', 'block', 'important');
                popup.style.setProperty('visibility', 'visible', 'important');
                popup.style.setProperty('opacity', '1', 'important');
              }
            }
          });
        }
      });
    }
  }

  // Initialize menu hide handler when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hidePopupsOnMenuOpen);
  } else {
    hidePopupsOnMenuOpen();
  }
})();

// Convert BCPO Shape Tape Color dropdown to swatches
(function() {
  'use strict';

  // Color mapping for Shape Tape Color
  const colorMap = {
    'beige': 'rgb(245, 245, 220)',
    'brown': 'rgb(139, 69, 19)',
    'black': 'rgb(0, 0, 0)'
  };

  function convertShapeTapeColorToSwatches() {
    // Find all BCPO selectors
    const bcpoSelectors = document.querySelectorAll('.selector-wrapper.bcpo-default');
    
    bcpoSelectors.forEach(function(wrapper) {
      const label = wrapper.querySelector('.bcpo-label .bcpo-title');
      if (!label) return;
      
      const labelText = label.textContent.trim().toLowerCase();
      
      // Check if this is "Shape Tape Color"
      if (labelText.includes('shape tape') && labelText.includes('color')) {
        const select = wrapper.querySelector('select.single-option-selector');
        if (!select) return;
        
        // Skip if already converted
        if (wrapper.dataset.convertedToSwatches === 'true') return;
        
        // Mark as converted
        wrapper.dataset.convertedToSwatches = 'true';
        
        // Store select properties before removal
        const selectName = select.name;
        const selectId = select.id;
        const selectRequired = select.hasAttribute('required');
        const selectAriaLabel = select.getAttribute('aria-label');
        const selectDataOption = select.getAttribute('data-option');
        const selectValue = select.value || '';
        
        // Get all options except the disabled "Choose one" BEFORE removing select
        const options = Array.from(select.options).filter(opt => !opt.disabled && opt.value);
        
        // Create hidden input to replace the select (for form submission)
        const hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = selectName;
        hiddenInput.id = selectId;
        hiddenInput.value = selectValue;
        if (selectRequired) {
          hiddenInput.setAttribute('required', '');
        }
        if (selectAriaLabel) {
          hiddenInput.setAttribute('aria-label', selectAriaLabel);
        }
        if (selectDataOption) {
          hiddenInput.setAttribute('data-option', selectDataOption);
        }
        
        // Insert hidden input before removing select
        select.parentNode.insertBefore(hiddenInput, select);
        
        // Remove the select dropdown from DOM completely
        select.remove();
        
        // Create swatch container
        const swatchContainer = document.createElement('div');
        swatchContainer.className = 'bcpo-swatch-container';
        swatchContainer.style.cssText = 'display: flex; flex-wrap: wrap; gap: 0.8rem; margin-top: 0.8rem; width: 100%;';
        
        options.forEach(function(option) {
          const value = option.value.toLowerCase().trim();
          const colorValue = colorMap[value] || 'rgb(200, 200, 200)';
          const isSelected = option.selected;
          
          // Create wrapper for radio and label
          const swatchWrapper = document.createElement('div');
          swatchWrapper.style.cssText = 'position: relative; display: inline-block;';
          
          // Create radio input
          const radio = document.createElement('input');
          radio.type = 'radio';
          radio.name = 'bcpo-swatch-' + selectName; // Use unique name for radio group
          radio.value = option.value;
          radio.id = 'bcpo-swatch-' + selectId + '-' + value.replace(/\s+/g, '-');
          radio.checked = isSelected;
          radio.className = 'swatch-input__input';
          radio.style.cssText = 'position: absolute; opacity: 0; width: 0; height: 0; margin: 0; padding: 0;';
          
          // Create label
          const labelEl = document.createElement('label');
          labelEl.className = 'swatch-input__label';
          labelEl.setAttribute('for', radio.id);
          labelEl.setAttribute('title', option.value);
          labelEl.style.cssText = 'display: inline-flex; align-items: center; justify-content: center; cursor: pointer; outline-offset: 0.2rem; transition: outline 0.2s ease;';
          
          // Create swatch span
          const swatch = document.createElement('span');
          swatch.className = 'swatch';
          swatch.style.cssText = 'display: block; width: 4.4rem; height: 4.4rem; min-width: 4.4rem; min-height: 4.4rem; border-radius: 50%; border: 0.1rem solid rgba(var(--color-foreground), 0.15); background: ' + colorValue + ' !important; --swatch--background: ' + colorValue + ';';
          
          // Add visually hidden text
          const hiddenText = document.createElement('span');
          hiddenText.className = 'visually-hidden';
          hiddenText.textContent = option.value;
          
          // Assemble elements
          labelEl.appendChild(swatch);
          labelEl.appendChild(hiddenText);
          swatchWrapper.appendChild(radio);
          swatchWrapper.appendChild(labelEl);
          swatchContainer.appendChild(swatchWrapper);
          
          // Add change handler to radio
          radio.addEventListener('change', function() {
            if (this.checked) {
              // Update hidden input value
              hiddenInput.value = option.value;
              
              // Trigger change event on hidden input (for BCPO app compatibility)
              const changeEvent = new Event('change', { bubbles: true });
              hiddenInput.dispatchEvent(changeEvent);
              
              // Also trigger input event
              const inputEvent = new Event('input', { bubbles: true });
              hiddenInput.dispatchEvent(inputEvent);
              
              // Check if there's a corresponding Shopify variant option and trigger variant selection
              // This ensures URL updates work if Shape Tape Color is also a variant option
              const variantSelects = document.querySelector('variant-selects');
              if (variantSelects) {
                // Find the actual Shopify variant option input for Shape Tape Color
                // Check both selects and radio inputs
                const variantSelectsList = variantSelects.querySelectorAll('select');
                const variantRadios = variantSelects.querySelectorAll('input[type="radio"]');
                
                let variantUpdated = false;
                
                // Helper function to check if label matches Shape Tape Color
                function isShapeTapeColor(labelText) {
                  const text = labelText.toLowerCase();
                  return (text.includes('shape tape') || text.includes('shapetape')) && 
                         (text.includes('color') || text.includes('colour'));
                }
                
                // Check selects first - also check by name attribute
                variantSelectsList.forEach(function(variantSelect) {
                  const variantLabel = variantSelect.closest('.product-form__input')?.querySelector('legend, label');
                  const selectName = variantSelect.name || '';
                  const nameMatch = selectName.toLowerCase().includes('shape') && 
                                   (selectName.toLowerCase().includes('color') || selectName.toLowerCase().includes('colour'));
                  
                  if (variantLabel && (isShapeTapeColor(variantLabel.textContent) || nameMatch)) {
                    // This is the Shape Tape Color variant option
                    // Find matching option value (case-insensitive)
                    const matchingOption = Array.from(variantSelect.options).find(function(opt) {
                      return opt.value.toLowerCase().trim() === option.value.toLowerCase().trim();
                    });
                    
                    if (matchingOption && variantSelect.value !== matchingOption.value) {
                      variantSelect.value = matchingOption.value;
                      // Trigger change event to update variant - this will trigger variant-selects handler
                      const changeEvent = new Event('change', { bubbles: true, cancelable: true });
                      variantSelect.dispatchEvent(changeEvent);
                      variantUpdated = true;
                    }
                  }
                });
                
                // Check radio inputs if select wasn't found
                if (!variantUpdated) {
                  // Group radios by their name to find the Shape Tape Color option group
                  const radioGroups = {};
                  variantRadios.forEach(function(variantRadio) {
                    const radioName = variantRadio.name;
                    if (!radioGroups[radioName]) {
                      radioGroups[radioName] = [];
                    }
                    radioGroups[radioName].push(variantRadio);
                  });
                  
                  // Check each radio group
                  Object.keys(radioGroups).forEach(function(radioName) {
                    if (variantUpdated) return;
                    
                    const radios = radioGroups[radioName];
                    const firstRadio = radios[0];
                    const variantLabel = firstRadio.closest('.product-form__input')?.querySelector('legend, label');
                    const nameMatch = radioName.toLowerCase().includes('shape') && 
                                     (radioName.toLowerCase().includes('color') || radioName.toLowerCase().includes('colour'));
                    
                    if (variantLabel && (isShapeTapeColor(variantLabel.textContent) || nameMatch)) {
                      // This is the Shape Tape Color variant option group
                      // Find the radio that matches the selected value
                      const matchingRadio = radios.find(function(radio) {
                        return radio.value.toLowerCase().trim() === option.value.toLowerCase().trim();
                      });
                      
                      if (matchingRadio && !matchingRadio.checked) {
                        matchingRadio.checked = true;
                        // Trigger change event to update variant - this will trigger variant-selects handler
                        const changeEvent = new Event('change', { bubbles: true, cancelable: true });
                        matchingRadio.dispatchEvent(changeEvent);
                        variantUpdated = true;
                      }
                    }
                  });
                }
              }
              
              // Update selected value display
              const valueSpan = wrapper.querySelector('.bcpo-value');
              if (valueSpan) {
                valueSpan.textContent = option.value;
              }
              
              // Update swatch selected state
              swatchContainer.querySelectorAll('.swatch-input__label').forEach(function(lbl) {
                lbl.style.outline = 'none';
              });
              labelEl.style.outline = '0.1rem solid rgb(var(--color-foreground))';
              labelEl.style.outlineOffset = '0.2rem';
            }
          });
          
          // Set initial selected state
          if (isSelected) {
            labelEl.style.outline = '0.1rem solid rgb(var(--color-foreground))';
            labelEl.style.outlineOffset = '0.2rem';
          }
        });
        
        // Insert swatch container after the label
        const bcpoLabel = wrapper.querySelector('.bcpo-label');
        if (bcpoLabel && bcpoLabel.parentNode) {
          bcpoLabel.parentNode.insertBefore(swatchContainer, bcpoLabel.nextSibling);
        }
      }
    });
  }

  // Initialize on page load
  function initShapeTapeColorSwatches() {
    convertShapeTapeColorToSwatches();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShapeTapeColorSwatches);
  } else {
    initShapeTapeColorSwatches();
  }

  // Also run after delays to catch dynamically loaded content
  setTimeout(initShapeTapeColorSwatches, 500);
  setTimeout(initShapeTapeColorSwatches, 1000);
  setTimeout(initShapeTapeColorSwatches, 2000);
  
  // Run on window load
  window.addEventListener('load', initShapeTapeColorSwatches);
  
  // Watch for dynamically added BCPO elements
  const observer = new MutationObserver(function(mutations) {
    let shouldConvert = false;
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes.length) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.classList.contains('bcpo-default') || node.querySelector('.bcpo-default'))) {
            shouldConvert = true;
          }
        });
      }
    });
    if (shouldConvert) {
      setTimeout(convertShapeTapeColorToSwatches, 100);
    }
  });

  // Start observing
  if (document.body) {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})();